module.exports = __webpack_public_path__ + "img/arrow-user.d481a77c.svg";